var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "step-contanier" },
    [
      _c(
        "div",
        { staticClass: "view scrollbar" },
        [
          _c(
            "div",
            {
              staticClass: "row",
              staticStyle: {
                "margin-left": "30px",
                "justify-content": "space-between",
              },
            },
            [
              _c(
                "div",
                [
                  _c(
                    "el-radio-group",
                    {
                      on: {
                        input: function ($event) {
                          _vm.form1.transportName = ""
                        },
                      },
                      model: {
                        value: _vm.billType,
                        callback: function ($$v) {
                          _vm.billType = $$v
                        },
                        expression: "billType",
                      },
                    },
                    _vm._l(_vm.billTypeItem, function (item) {
                      return _c(
                        "el-radio-button",
                        { key: item.id, attrs: { label: item.id } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  ),
                  _c("span", { staticClass: "transportName" }, [
                    _vm._v(_vm._s(_vm.form1.transportName)),
                  ]),
                ],
                1
              ),
            ]
          ),
          _c(
            "BasePanel",
            {
              staticStyle: { "margin-top": "10px" },
              attrs: { height: "40px", title: "提单信息" },
            },
            [
              _c(
                "div",
                { staticClass: "content" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "billInfo",
                      attrs: {
                        model: _vm.form1,
                        rules: _vm.rules1,
                        "label-position": "top",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        { staticClass: "row", attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "mblNo", label: "主单号" } },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      size: "small",
                                      placeholder: "请输入主单号",
                                    },
                                    on: {
                                      blur: _vm.changeMblNo,
                                      input: function ($event) {
                                        return _vm.onInput("mblNo")
                                      },
                                    },
                                    model: {
                                      value: _vm.form1.mblNo,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form1, "mblNo", $$v)
                                      },
                                      expression: "form1.mblNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "blNo", label: "分单号" } },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      size: "small",
                                      placeholder: "请输入分单号",
                                    },
                                    on: {
                                      blur: _vm.changeMblNo,
                                      input: function ($event) {
                                        return _vm.onInput("blNo")
                                      },
                                    },
                                    model: {
                                      value: _vm.form1.blNo,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form1, "blNo", $$v)
                                      },
                                      expression: "form1.blNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "date", label: "ETD - ETA" } },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      type: "daterange",
                                      "unlink-panels": "",
                                      size: "small",
                                      "picker-options": _vm.pickerOptions,
                                      "value-format": "yyyy-MM-dd",
                                      "range-separator": "-",
                                      "start-placeholder": "请选择日期",
                                      "end-placeholder": "请选择日期",
                                    },
                                    model: {
                                      value: _vm.form1.date,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form1, "date", $$v)
                                      },
                                      expression: "form1.date",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "dischargeHarborDate",
                                    label: "到卸货港日期",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      size: "small",
                                      type: "datetime",
                                      placeholder: "请选择到卸货港日期",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                    },
                                    model: {
                                      value: _vm.form1.dischargeHarborDate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form1,
                                          "dischargeHarborDate",
                                          $$v
                                        )
                                      },
                                      expression: "form1.dischargeHarborDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "countryCode",
                                    label: "目的国家",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        size: "small",
                                        placeholder: "请选择目的国家",
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.form1.destinationHarborName = ""
                                        },
                                      },
                                      model: {
                                        value: _vm.form1.countryCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form1,
                                            "countryCode",
                                            $$v
                                          )
                                        },
                                        expression: "form1.countryCode",
                                      },
                                    },
                                    _vm._l(
                                      _vm.addressDropCodeOption,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.label,
                                            value: item.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "companyId", label: "客户" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        size: "small",
                                        placeholder: "请选择客户",
                                      },
                                      model: {
                                        value: _vm.form1.companyId,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form1, "companyId", $$v)
                                        },
                                        expression: "form1.companyId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.companyDrapdown,
                                      function (item, $index) {
                                        return _c("el-option", {
                                          key: $index,
                                          attrs: {
                                            label: item.label,
                                            value: item.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { staticClass: "row", attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "originHarborName",
                                    label: "始发港",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        size: "small",
                                        filterable: "",
                                        placeholder: "请选择始发港",
                                      },
                                      model: {
                                        value: _vm.form1.originHarborName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form1,
                                            "originHarborName",
                                            $$v
                                          )
                                        },
                                        expression: "form1.originHarborName",
                                      },
                                    },
                                    _vm._l(
                                      _vm.orginPortOptions,
                                      function (item, $index) {
                                        return _c("el-option", {
                                          key: $index,
                                          attrs: {
                                            label: item.label,
                                            value: item.label,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "destinationHarborName",
                                    label: "目的港",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        size: "small",
                                        placeholder: "请选择目的港",
                                      },
                                      model: {
                                        value: _vm.form1.destinationHarborName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form1,
                                            "destinationHarborName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form1.destinationHarborName",
                                      },
                                    },
                                    _vm._l(
                                      _vm.destinPortOptions,
                                      function (item, $index) {
                                        return _c("el-option", {
                                          key: $index,
                                          attrs: {
                                            label: item.label,
                                            value: item.label,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "dischargeHarbor",
                                    label: "卸货港",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        size: "small",
                                        placeholder: "请选择目的港",
                                      },
                                      model: {
                                        value: _vm.form1.dischargeHarbor,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form1,
                                            "dischargeHarbor",
                                            $$v
                                          )
                                        },
                                        expression: "form1.dischargeHarbor",
                                      },
                                    },
                                    _vm._l(
                                      _vm.destinPortOptions,
                                      function (item, $index) {
                                        return _c("el-option", {
                                          key: $index,
                                          attrs: {
                                            label: item.label,
                                            value: item.label,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.billType
                            ? [
                                _c(
                                  "el-col",
                                  { attrs: { span: 4 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "qty",
                                          label: "提单件数(件)",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            size: "small",
                                            placeholder: "请输入提单件数",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.onInput("qty")
                                            },
                                          },
                                          model: {
                                            value: _vm.form1.qty,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form1, "qty", $$v)
                                            },
                                            expression: "form1.qty",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 4 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "weightCbm",
                                          label: "方数(CBM)",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            size: "small",
                                            placeholder: "请输入方数",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.onInput("weightCbm")
                                            },
                                          },
                                          model: {
                                            value: _vm.form1.weightCbm,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form1,
                                                "weightCbm",
                                                $$v
                                              )
                                            },
                                            expression: "form1.weightCbm",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 4 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "weightKgs",
                                          label: "重量(KG)",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            size: "small",
                                            placeholder: "请输入重量",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.onInput("weightKgs")
                                            },
                                          },
                                          model: {
                                            value: _vm.form1.weightKgs,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form1,
                                                "weightKgs",
                                                $$v
                                              )
                                            },
                                            expression: "form1.weightKgs",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : [
                                _c(
                                  "el-col",
                                  { attrs: { span: 4 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "originCountry",
                                          label: "原产国",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              filterable: "",
                                              disabled: "",
                                              size: "small",
                                              placeholder: "请选择原产国",
                                            },
                                            model: {
                                              value: _vm.form1.originCountry,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form1,
                                                  "originCountry",
                                                  $$v
                                                )
                                              },
                                              expression: "form1.originCountry",
                                            },
                                          },
                                          _vm._l(
                                            _vm.addressDropCodeOption,
                                            function (item, index) {
                                              return _c("el-option", {
                                                key: index,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.value,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                        ],
                        2
                      ),
                      _vm.billType
                        ? _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 4 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop: "originCountry",
                                        label: "原产国",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            filterable: "",
                                            disabled: "",
                                            size: "small",
                                            placeholder: "请选择原产国",
                                          },
                                          model: {
                                            value: _vm.form1.originCountry,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form1,
                                                "originCountry",
                                                $$v
                                              )
                                            },
                                            expression: "form1.originCountry",
                                          },
                                        },
                                        _vm._l(
                                          _vm.addressDropCodeOption,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: item.label,
                                                value: item.value,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-row",
                        { staticClass: "row", attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { prop: "consigneeName" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-item_label",
                                      attrs: { slot: "label" },
                                      slot: "label",
                                    },
                                    [
                                      _c("span", [_vm._v("收货人/Consignee")]),
                                      _c("div", [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "add",
                                            on: {
                                              click: function ($event) {
                                                return _vm.add(20)
                                              },
                                            },
                                          },
                                          [
                                            _c("svg-icon", {
                                              attrs: {
                                                iconClass: "add",
                                                className: "icon",
                                              },
                                            }),
                                            _vm._v("添加"),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        placeholder: "请选择",
                                      },
                                      on: { change: _vm.changeConsignee },
                                      model: {
                                        value: _vm.form1.consigneeName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form1,
                                            "consigneeName",
                                            $$v
                                          )
                                        },
                                        expression: "form1.consigneeName",
                                      },
                                    },
                                    _vm._l(
                                      _vm.consigneeOptions,
                                      function (item, index) {
                                        return _c(
                                          "el-option",
                                          {
                                            key: index,
                                            attrs: {
                                              label: item.label,
                                              value: item.label,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: { float: "left" },
                                              },
                                              [_vm._v(_vm._s(item.label))]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  float: "right",
                                                  color: "#8492a6",
                                                  "font-size": "13px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.address)
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.cityAddress)
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.provinceEnName)
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.countryName)
                                                    ) +
                                                    " "
                                                ),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item?.postcode
                                                        ? item?.postcode
                                                        : ""
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { prop: "shipperName" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-item_label",
                                      attrs: { slot: "label" },
                                      slot: "label",
                                    },
                                    [
                                      _c("span", [_vm._v("发货人/Shipper")]),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "add",
                                          on: {
                                            click: function ($event) {
                                              return _vm.add(20)
                                            },
                                          },
                                        },
                                        [
                                          _c("svg-icon", {
                                            attrs: {
                                              iconClass: "add",
                                              className: "icon",
                                            },
                                          }),
                                          _vm._v("添加"),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        placeholder: "请选择",
                                      },
                                      on: { change: _vm.changeShipper },
                                      model: {
                                        value: _vm.form1.shipperName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form1,
                                            "shipperName",
                                            $$v
                                          )
                                        },
                                        expression: "form1.shipperName",
                                      },
                                    },
                                    _vm._l(
                                      _vm.shipperOptions,
                                      function (item, index) {
                                        return _c(
                                          "el-option",
                                          {
                                            key: index,
                                            attrs: {
                                              label: item.label,
                                              value: item.label,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: { float: "left" },
                                              },
                                              [_vm._v(_vm._s(item.label))]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  float: "right",
                                                  color: "#8492a6",
                                                  "font-size": "13px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.address)
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.cityAddress)
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.provinceEnName)
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.countryName)
                                                    ) +
                                                    " "
                                                ),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item?.postcode
                                                        ? item?.postcode
                                                        : ""
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { prop: "notifyPartyName" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-item_label",
                                      attrs: { slot: "label" },
                                      slot: "label",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v("通知方/Notify party"),
                                      ]),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "add",
                                          on: {
                                            click: function ($event) {
                                              return _vm.add(20)
                                            },
                                          },
                                        },
                                        [
                                          _c("svg-icon", {
                                            attrs: {
                                              iconClass: "add",
                                              className: "icon",
                                            },
                                          }),
                                          _vm._v("添加"),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        placeholder: "请选择",
                                      },
                                      model: {
                                        value: _vm.form1.notifyPartyName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form1,
                                            "notifyPartyName",
                                            $$v
                                          )
                                        },
                                        expression: "form1.notifyPartyName",
                                      },
                                    },
                                    _vm._l(
                                      _vm.notifyPartyOptions,
                                      function (item, index) {
                                        return _c(
                                          "el-option",
                                          {
                                            key: index,
                                            attrs: {
                                              label: item.label,
                                              value: item.label,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: { float: "left" },
                                              },
                                              [_vm._v(_vm._s(item.label))]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  float: "right",
                                                  color: "#8492a6",
                                                  "font-size": "13px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.address)
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.cityAddress)
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.provinceEnName)
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.countryName)
                                                    ) +
                                                    " "
                                                ),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item?.postcode
                                                        ? item?.postcode
                                                        : ""
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { staticClass: "row", attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { prop: "manufacturerName" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-item_label",
                                      attrs: { slot: "label" },
                                      slot: "label",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v("制造商/Manufacturer"),
                                      ]),
                                      _c("div", [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "add",
                                            on: {
                                              click: function ($event) {
                                                return _vm.add(20)
                                              },
                                            },
                                          },
                                          [
                                            _c("svg-icon", {
                                              attrs: {
                                                iconClass: "add",
                                                className: "icon",
                                              },
                                            }),
                                            _vm._v("添加"),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                          },
                                          [
                                            _c("el-switch", {
                                              attrs: {
                                                "active-text": "同发货人",
                                              },
                                              model: {
                                                value: _vm.isSameShipper,
                                                callback: function ($$v) {
                                                  _vm.isSameShipper = $$v
                                                },
                                                expression: "isSameShipper",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        placeholder: "请选择",
                                      },
                                      on: {
                                        change: _vm.manufacturerNameChange,
                                      },
                                      model: {
                                        value: _vm.form1.manufacturerName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form1,
                                            "manufacturerName",
                                            $$v
                                          )
                                        },
                                        expression: "form1.manufacturerName",
                                      },
                                    },
                                    _vm._l(
                                      _vm.manufacturerOptions,
                                      function (item, index) {
                                        return _c(
                                          "el-option",
                                          {
                                            key: index,
                                            attrs: {
                                              label: item.label,
                                              value: item.label,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: { float: "left" },
                                              },
                                              [_vm._v(_vm._s(item.label))]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  float: "right",
                                                  color: "#8492a6",
                                                  "font-size": "13px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.address)
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.cityAddress)
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.provinceEnName)
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.countryName)
                                                    ) +
                                                    " "
                                                ),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item?.postcode
                                                        ? item?.postcode
                                                        : ""
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { prop: "importerName" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-item_label",
                                      attrs: { slot: "label" },
                                      slot: "label",
                                    },
                                    [
                                      _c("span", [_vm._v("进口商/Importer")]),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-left": "10px",
                                          },
                                        },
                                        [
                                          _c("el-switch", {
                                            attrs: {
                                              "active-text": "同收货人",
                                            },
                                            model: {
                                              value: _vm.isSameConsignee,
                                              callback: function ($$v) {
                                                _vm.isSameConsignee = $$v
                                              },
                                              expression: "isSameConsignee",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        placeholder: "请选择",
                                      },
                                      model: {
                                        value: _vm.form1.importerName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form1,
                                            "importerName",
                                            $$v
                                          )
                                        },
                                        expression: "form1.importerName",
                                      },
                                    },
                                    _vm._l(
                                      _vm.importerList,
                                      function (item, index) {
                                        return _c(
                                          "el-option",
                                          {
                                            key: index,
                                            attrs: {
                                              label: item.name,
                                              value: item.name,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: { float: "left" },
                                              },
                                              [_vm._v(_vm._s(item.name))]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  float: "right",
                                                  color: "#8492a6",
                                                  "font-size": "13px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.address)
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.cityAddress)
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.provinceEnName)
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.countryName)
                                                    ) +
                                                    " "
                                                ),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item?.postcode
                                                        ? item?.postcode
                                                        : ""
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { prop: "ultimateConsigneeName" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-item_label",
                                      attrs: { slot: "label" },
                                      slot: "label",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v("最终收货人/Ultimate Consignee"),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "add",
                                            on: {
                                              click: function ($event) {
                                                return _vm.add(20)
                                              },
                                            },
                                          },
                                          [
                                            _c("svg-icon", {
                                              attrs: {
                                                iconClass: "add",
                                                className: "icon",
                                              },
                                            }),
                                            _vm._v("添加"),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                          },
                                          [
                                            _c("el-switch", {
                                              attrs: {
                                                "active-text": "同收货人",
                                              },
                                              model: {
                                                value:
                                                  _vm.isSameConsigneeToUltimateConsignee,
                                                callback: function ($$v) {
                                                  _vm.isSameConsigneeToUltimateConsignee =
                                                    $$v
                                                },
                                                expression:
                                                  "isSameConsigneeToUltimateConsignee",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        placeholder: "请选择",
                                      },
                                      model: {
                                        value: _vm.form1.ultimateConsigneeName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form1,
                                            "ultimateConsigneeName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form1.ultimateConsigneeName",
                                      },
                                    },
                                    _vm._l(
                                      _vm.ultimateConsigneeOptions,
                                      function (item, index) {
                                        return _c(
                                          "el-option",
                                          {
                                            key: index,
                                            attrs: {
                                              label: item.label,
                                              value: item.label,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: { float: "left" },
                                              },
                                              [_vm._v(_vm._s(item.label))]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  float: "right",
                                                  color: "#8492a6",
                                                  "font-size": "13px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.address)
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.cityAddress)
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.provinceEnName)
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "formatStatusAddress"
                                                      )(item?.countryName)
                                                    ) +
                                                    " "
                                                ),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item?.postcode
                                                        ? item?.postcode
                                                        : ""
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          !_vm.billType
            ? _c(
                "BasePanel",
                {
                  staticStyle: { "margin-top": "12px" },
                  attrs: { height: "40px", title: "柜子信息" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "panel-opt",
                      attrs: { slot: "opt" },
                      slot: "opt",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "add flex_c_c",
                          on: { click: _vm.addCabinet },
                        },
                        [
                          _c("svg-icon", {
                            attrs: { className: "icon", iconClass: "add" },
                          }),
                          _vm._v(" 新增柜子 "),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "content" },
                    _vm._l(_vm.form2Data, function (item, $index) {
                      return _c(
                        "div",
                        { key: $index, staticClass: "cabinet-item" },
                        [
                          _vm.form2Data.length !== 1
                            ? _c("img", {
                                staticClass: "delete-cabinet",
                                attrs: {
                                  src: require("@/assets/images/bill/delete-cabinet.png"),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteCabinet($index)
                                  },
                                },
                              })
                            : _vm._e(),
                          _c(
                            "el-form",
                            {
                              ref: `containerInfo${$index}`,
                              refInFor: true,
                              attrs: {
                                model: item,
                                rules: _vm.rules2,
                                "label-position": "top",
                              },
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "柜号",
                                    prop: "containerNumber",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "260px" },
                                    attrs: {
                                      placeholder: "仅限输入数字和英文字符",
                                      size: "small",
                                      maxlength: 11,
                                      oninput:
                                        "value=value.replace(/[^0-9a-zA-Z]/g, '')",
                                    },
                                    model: {
                                      value: item.containerNumber,
                                      callback: function ($$v) {
                                        _vm.$set(item, "containerNumber", $$v)
                                      },
                                      expression: "item.containerNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "柜型",
                                    prop: "containertype",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "150px" },
                                      attrs: {
                                        filterable: "",
                                        size: "small",
                                        placeholder: "请选择柜型",
                                      },
                                      model: {
                                        value: item.containertype,
                                        callback: function ($$v) {
                                          _vm.$set(item, "containertype", $$v)
                                        },
                                        expression: "item.containertype",
                                      },
                                    },
                                    _vm._l(
                                      _vm.config.containertypeOptions,
                                      function (op, opi) {
                                        return _c("el-option", {
                                          key: opi,
                                          attrs: {
                                            label: op.label,
                                            value: op.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { prop: "vesselName", label: "船名" },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "150px" },
                                      attrs: {
                                        filterable: "",
                                        size: "small",
                                        "allow-create": "",
                                        placeholder: "请选择船名",
                                        "default-first-option": "",
                                      },
                                      on: {
                                        blur: function ($event) {
                                          return _vm.onTypeBlur($event)
                                        },
                                      },
                                      model: {
                                        value: item.vesselName,
                                        callback: function ($$v) {
                                          _vm.$set(item, "vesselName", $$v)
                                        },
                                        expression: "item.vesselName",
                                      },
                                    },
                                    _vm._l(
                                      _vm.vesselNameOptions,
                                      function (vesselName) {
                                        return _c("el-option", {
                                          key: vesselName.value,
                                          attrs: {
                                            label: vesselName.label,
                                            value: vesselName.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "voyageNo",
                                    label: "船次/航次",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "150px" },
                                    attrs: {
                                      size: "small",
                                      placeholder: "请输入船次/航次",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.onInput("voyageNo")
                                      },
                                    },
                                    model: {
                                      value: item.voyageNo,
                                      callback: function ($$v) {
                                        _vm.$set(item, "voyageNo", $$v)
                                      },
                                      expression: "item.voyageNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { prop: "qty", label: "提单件数(件)" },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      size: "small",
                                      placeholder: "请输入提单件数",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.onInput("qty")
                                      },
                                    },
                                    model: {
                                      value: item.qty,
                                      callback: function ($$v) {
                                        _vm.$set(item, "qty", $$v)
                                      },
                                      expression: "item.qty",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "weightCbm",
                                    label: "方数(CBM)",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      size: "small",
                                      placeholder: "请输入方数",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.onInput("weightCbm")
                                      },
                                    },
                                    model: {
                                      value: item.weightCbm,
                                      callback: function ($$v) {
                                        _vm.$set(item, "weightCbm", $$v)
                                      },
                                      expression: "item.weightCbm",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "weightKgs",
                                    label: "重量(KG)",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      size: "small",
                                      placeholder: "请输入重量",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.onInput("weightKgs")
                                      },
                                    },
                                    model: {
                                      value: item.weightKgs,
                                      callback: function ($$v) {
                                        _vm.$set(item, "weightKgs", $$v)
                                      },
                                      expression: "item.weightKgs",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { prop: "routeLine2", label: "航线" },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      size: "small",
                                      placeholder: "请输入",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.onInput("routeLine")
                                      },
                                    },
                                    model: {
                                      value: item.routeLine,
                                      callback: function ($$v) {
                                        _vm.$set(item, "routeLine", $$v)
                                      },
                                      expression: "item.routeLine",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "封条号",
                                    prop: "sealNumber",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "160px" },
                                    attrs: {
                                      size: "small",
                                      placeholder: "请输入封条号",
                                    },
                                    model: {
                                      value: item.sealNumber,
                                      callback: function ($$v) {
                                        _vm.$set(item, "sealNumber", $$v)
                                      },
                                      expression: "item.sealNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "bill-detail" },
            [
              _c(
                "el-form",
                {
                  ref: "billDetailInfo",
                  staticStyle: { width: "calc(100% - 64px)" },
                  attrs: {
                    model: _vm.form3,
                    rules: _vm.rules3,
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "BasePanel",
                            {
                              staticStyle: { "margin-top": "10px" },
                              attrs: { height: "40px", title: "清关方式" },
                            },
                            [
                              !_vm.billType
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "panel-opt",
                                      attrs: { slot: "opt" },
                                      slot: "opt",
                                    },
                                    [
                                      _vm.form3.clearenceType === 1 &&
                                      _vm.form3.isDeclareISF
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "add flex_c_c",
                                              on: {
                                                click: function ($event) {
                                                  _vm.drawer = true
                                                  _vm.isShowIsf = true
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                class: !_vm.isf
                                                  ? "el-icon-warning-outline"
                                                  : "el-icon-circle-check",
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    !_vm.isf
                                                      ? "未填写ISF"
                                                      : "已填写ISF"
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "content" },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.form3.clearenceType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form3,
                                            "clearenceType",
                                            $$v
                                          )
                                        },
                                        expression: "form3.clearenceType",
                                      },
                                    },
                                    _vm._l(_vm.tabItems1, function (item) {
                                      return _c(
                                        "el-radio-button",
                                        {
                                          key: item.id,
                                          attrs: { label: item.id },
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    }),
                                    1
                                  ),
                                  _c("el-switch", {
                                    staticStyle: { "margin-left": "12px" },
                                    attrs: {
                                      "active-color": "#13ce66",
                                      "active-text": "是否申报ISF",
                                      "inactive-color": "#ff4949",
                                    },
                                    model: {
                                      value: _vm.form3.isDeclareISF,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form3, "isDeclareISF", $$v)
                                      },
                                      expression: "form3.isDeclareISF",
                                    },
                                  }),
                                  _vm.form3.clearenceType === 1
                                    ? [
                                        _c(
                                          "el-row",
                                          { attrs: { gutter: 20 } },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 12 } },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      prop: "receivedDoEmail",
                                                      label:
                                                        "接收DO邮箱（可多条输入）",
                                                    },
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      staticStyle: {
                                                        width: "360px",
                                                      },
                                                      attrs: {
                                                        placeholder:
                                                          "接收DO邮箱（可多条输入）以,隔开",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form3
                                                            .receivedDoEmail,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form3,
                                                            "receivedDoEmail",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form3.receivedDoEmail",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 12 } },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      prop: "receivedDoCompany",
                                                      label: "接收DO公司名称",
                                                    },
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      staticStyle: {
                                                        width: "360px",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form3
                                                            .receivedDoCompany,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form3,
                                                            "receivedDoCompany",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form3.receivedDoCompany",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-row",
                                          { attrs: { gutter: 20 } },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 12 } },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      prop: "clearanceMode",
                                                      label: "清关模式",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "360px",
                                                        },
                                                        attrs: {
                                                          clearable: "",
                                                          placeholder:
                                                            "请选择清关模式",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.form3
                                                              .clearanceMode,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form3,
                                                              "clearanceMode",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form3.clearanceMode",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.config
                                                          .clearanceModesOptions,
                                                        function (item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item.value,
                                                              attrs: {
                                                                label:
                                                                  item.label,
                                                                value:
                                                                  item.value,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "BasePanel",
                            {
                              staticStyle: { "margin-top": "10px" },
                              attrs: { height: "40px", title: "提货方式" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "content" },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.form3.pickUpType,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form3, "pickUpType", $$v)
                                        },
                                        expression: "form3.pickUpType",
                                      },
                                    },
                                    _vm._l(_vm.tabItems2, function (item) {
                                      return _c(
                                        "el-radio-button",
                                        {
                                          key: item.id,
                                          attrs: { label: item.id },
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    }),
                                    1
                                  ),
                                  _vm.form3.pickUpType === 1
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "row",
                                            staticStyle: {
                                              "margin-top": "14px",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "field" },
                                              [
                                                _c("label", [
                                                  _c(
                                                    "span",
                                                    { staticClass: "require" },
                                                    [_vm._v("* ")]
                                                  ),
                                                  _vm._v("选择直送类型"),
                                                ]),
                                                _c(
                                                  "el-radio-group",
                                                  {
                                                    on: {
                                                      input: function ($event) {
                                                        _vm.form3.code = ""
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form3.deliveryType,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form3,
                                                          "deliveryType",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form3.deliveryType",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        staticStyle: {
                                                          "margin-left": "10px",
                                                        },
                                                        attrs: { label: 2 },
                                                      },
                                                      [_vm._v("私仓")]
                                                    ),
                                                    _c(
                                                      "el-radio",
                                                      { attrs: { label: 1 } },
                                                      [_vm._v("亚马逊仓")]
                                                    ),
                                                    _c(
                                                      "el-radio",
                                                      { attrs: { label: 0 } },
                                                      [_vm._v("快递商")]
                                                    ),
                                                    _c(
                                                      "el-radio",
                                                      { attrs: { label: 5 } },
                                                      [_vm._v("沃尔玛仓")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm.form3.deliveryType
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "row",
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      staticStyle: {
                                                        width: "100%",
                                                      },
                                                      attrs: { prop: "code" },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-item_label",
                                                          attrs: {
                                                            slot: "label",
                                                          },
                                                          slot: "label",
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v("选择仓库"),
                                                          ]),
                                                          _vm.form3
                                                            .deliveryType === 2
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "add",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.add(
                                                                          0
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "svg-icon",
                                                                    {
                                                                      attrs: {
                                                                        iconClass:
                                                                          "add",
                                                                        className:
                                                                          "icon",
                                                                      },
                                                                    }
                                                                  ),
                                                                  _vm._v(
                                                                    "新增"
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          attrs: {
                                                            filterable: "",
                                                            clearable: "",
                                                            placeholder:
                                                              "请选择",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.form3.code,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form3,
                                                                "code",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form3.code",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.warehouseList,
                                                          function (item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.label,
                                                                attrs: {
                                                                  label:
                                                                    item.label,
                                                                  value:
                                                                    item.label,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        float:
                                                                          "left",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.label
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        float:
                                                                          "right",
                                                                        color:
                                                                          "#8492a6",
                                                                        "font-size":
                                                                          "13px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "formatStatusAddress"
                                                                          )(
                                                                            item?.address
                                                                          )
                                                                        ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "formatStatusAddress"
                                                                          )(
                                                                            item?.city
                                                                          )
                                                                        ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "formatStatusAddress"
                                                                          )(
                                                                            item?.provinceEnName
                                                                          )
                                                                        ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "formatStatusAddress"
                                                                          )(
                                                                            item?.countryName
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    _c(
                                                                      "strong",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item?.postcode
                                                                              ? item?.postcode
                                                                              : ""
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm.form3.deliveryType === 0
                                          ? _c(
                                              "div",
                                              { staticClass: "row" },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      prop: "expressSupplier",
                                                      label: "选择快递商",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "supplyList",
                                                      },
                                                      _vm._l(
                                                        _vm.config
                                                          .expressSupplierOptions,
                                                        function (
                                                          item,
                                                          $index
                                                        ) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key: item.value,
                                                              staticClass:
                                                                "item",
                                                              class: {
                                                                active:
                                                                  _vm.kdSupplyIndex ===
                                                                  $index,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.kdSupplyIndex =
                                                                      $index
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("img", {
                                                                staticClass:
                                                                  "logoUrl",
                                                                attrs: {
                                                                  src: require(`@/assets/images/serverSupply/${item.value.toLowerCase()}.png`),
                                                                },
                                                              }),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pageBtn" },
        [
          _c(
            "el-button",
            {
              staticStyle: { position: "absolute", left: "20px" },
              attrs: { type: "text" },
              on: { click: _vm.download },
            },
            [
              _c("svg-icon", {
                attrs: { iconClass: "download", className: "icon" },
              }),
              _vm._v(" 下载预报模板 "),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "btn btn-defalut flex_c_c",
              on: { click: _vm.resetFields },
            },
            [_vm._v("重置")]
          ),
          _c(
            "div",
            {
              staticClass: "btn btn-primary flex_c_c",
              on: { click: _vm.nextStep },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
      _c("warehouseadd-dialog", {
        attrs: {
          isSelectType: false,
          dialogVisible: _vm.dialogVisible,
          activeName: _vm.warehouseType.toString(),
        },
        on: {
          ok: _vm.ok,
          cancel: function ($event) {
            _vm.dialogVisible = false
          },
        },
      }),
      _vm.drawer
        ? _c("ISFDrawer", {
            attrs: {
              drawer: _vm.drawer,
              scinList: _vm.scinList,
              importerList: _vm.importerList,
              companyId: _vm.form1.companyId,
              shipperName: _vm.form1.shipperName,
              billType: _vm.billType,
              consigneeName: _vm.form1.consigneeName,
              importerName: _vm.form1.importerName,
              notifyPartyName: _vm.form1.notifyPartyName,
              manufacturerName: _vm.form1.manufacturerName,
              ultimateConsigneeName: _vm.form1.ultimateConsigneeName,
              blNo: _vm.form1.blNo || _vm.form1.mblNo,
              masterType: _vm.form1.blNo ? 1 : 0,
              etd: _vm.form1.date[0],
              editISF: _vm.isf || {},
            },
            on: {
              ok: _vm.ok1,
              close: function ($event) {
                ;(_vm.drawer = false), (_vm.isShowIsf = true)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }